import React, { useEffect, useRef, useState } from 'react';

import { LIMITES } from '../Helpers/paginacion';

// 1 … 4 5 6 … 20: la primera, la última y dos alrededor de la actual
const numerosVisibles = (pagina, paginas) => {
    const numeros = [];
    for (let n = 1; n <= paginas; n++) {
        if (n === 1 || n === paginas || Math.abs(n - pagina) <= 2) numeros.push(n);
        else if (numeros[numeros.length - 1] !== '…') numeros.push('…');
    }
    return numeros;
};

// Barra fija abajo mientras se recorre la lista. Al cambiar de página o de cantidad, la vista regresa al inicio de la lista
const Paginacion = ({ pagina, limite, total, onPagina, onLimite }) => {
    const ref = useRef(null);
    const paginas = Math.max(Math.ceil(total / limite), 1);
    const desde = total ? (pagina - 1) * limite + 1 : 0;
    const hasta = Math.min(pagina * limite, total);
    const [salto, setSalto] = useState(String(pagina));

    useEffect(() => {
        setSalto(String(pagina));
    }, [pagina]);

    const subir = () => {
        const lista = ref.current?.closest('.lista_admin');
        if (lista && lista.getBoundingClientRect().top < 0) lista.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    const ir = n => {
        const destino = Math.min(Math.max(n, 1), paginas);
        if (destino === pagina) return setSalto(String(pagina));
        onPagina(destino);
        subir();
    };

    const saltar = e => {
        e.preventDefault();
        const n = Number(salto);
        if (Number.isInteger(n)) ir(n);
        else setSalto(String(pagina));
    };

    const cambiarLimite = nuevo => {
        onLimite(nuevo);
        subir();
    };

    return (
        <nav ref={ref} className='paginacion_admin' aria-label='Paginación'>
            <label className='paginacion_admin_limite'>
                Mostrar
                <select className='browser-default' value={limite} onChange={e => cambiarLimite(Number(e.target.value))}>
                    {LIMITES.map(opcion => <option key={opcion} value={opcion}>{opcion}</option>)}
                </select>
                por página
            </label>
            <span className='paginacion_admin_rango'>{desde.toLocaleString('es-MX')}–{hasta.toLocaleString('es-MX')} de {total.toLocaleString('es-MX')}</span>
            <div className='paginacion_admin_paginas'>
                <button type='button' onClick={() => ir(1)} disabled={pagina <= 1} aria-label='Primera página' title='Primera página'>
                    <i className='material-icons'>first_page</i>
                </button>
                <button type='button' onClick={() => ir(pagina - 1)} disabled={pagina <= 1} aria-label='Página anterior' title='Página anterior'>
                    <i className='material-icons'>chevron_left</i>
                </button>
                <span className='paginacion_admin_numeros'>
                    {numerosVisibles(pagina, paginas).map((n, i) => (
                        n === '…' ? (
                            <span key={'salto' + i} className='paginacion_admin_salto'>…</span>
                        ) : (
                            <button type='button' key={n} onClick={() => ir(n)} className={n === pagina ? 'paginacion_admin_actual' : undefined} aria-current={n === pagina ? 'page' : undefined}>
                                {n}
                            </button>
                        )
                    ))}
                </span>
                <button type='button' onClick={() => ir(pagina + 1)} disabled={pagina >= paginas} aria-label='Página siguiente' title='Página siguiente'>
                    <i className='material-icons'>chevron_right</i>
                </button>
                <button type='button' onClick={() => ir(paginas)} disabled={pagina >= paginas} aria-label='Última página' title='Última página'>
                    <i className='material-icons'>last_page</i>
                </button>
            </div>
            {paginas > 1 && (
                <form className='paginacion_admin_ir' onSubmit={saltar}>
                    <label htmlFor='paginacion_ir'>Ir a</label>
                    <input
                        id='paginacion_ir'
                        type='number'
                        className='browser-default'
                        min='1'
                        max={paginas}
                        value={salto}
                        onChange={e => setSalto(e.target.value)}
                        onBlur={() => setSalto(String(pagina))}
                    />
                    <span>de {paginas.toLocaleString('es-MX')}</span>
                </form>
            )}
        </nav>
    );
};

export default Paginacion;
